import {FC, useState} from 'react';
import {Box} from '@mui/material';
import {useAppSelector} from '@/store/hooks';
import {getUserSelector} from '@/store/user/selector';
import ChangePasswordModalStep1 from './ChangePasswordModalStep1';
import ChangePasswordModalStep2 from './ChangePasswordModalStep2';
import ChangePasswordModalStep3 from './ChangePasswordModalStep3';
import {userAPI} from '@/core/api';
import {UserService} from '@/utils/services';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';

interface ConfirmationModalProps {
	onCloseModal: () => void;
}

enum Steps {
	STEP_1,
	STEP_2,
	STEP_3,
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({onCloseModal}) => {
	const [formStep, setFormStep] = useState(Steps.STEP_1);

	const handleSubmitStep1 = async (values: {password: string}) => {
		try {
			await UserService.verifyOldPassword({oldPassword: values.password}, userAPI);
			setFormStep(Steps.STEP_2);
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	const user = useAppSelector(getUserSelector);

	const handleSubmitStep2 = async (values: {password: string; confirmPassword: string}) => {
		if (!user || !user.id) return;
		try {
			const params = {
				changingPassword: values.password,
				confirmChangePassword: values.confirmPassword,
			};
			await UserService.setNewPassword(params, userAPI);
			setFormStep(Steps.STEP_3);
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	switch (formStep) {
		case Steps.STEP_1:
			return (
				<Box sx={{width: '100%'}}>
					<ChangePasswordModalStep1 onCloseModal={onCloseModal} handleSubmit={handleSubmitStep1} />
				</Box>
			);
		case Steps.STEP_2:
			return (
				<Box sx={{width: '100%'}}>
					<ChangePasswordModalStep2 onCloseModal={onCloseModal} handleSubmit={handleSubmitStep2} />
				</Box>
			);
		case Steps.STEP_3:
			return (
				<Box sx={{width: '100%'}}>
					<ChangePasswordModalStep3 onCloseModal={onCloseModal} />
				</Box>
			);
		default:
			return (
				<Box sx={{width: '100%'}}>
					<ChangePasswordModalStep1 onCloseModal={onCloseModal} handleSubmit={handleSubmitStep1} />
				</Box>
			);
	}
};

export default ConfirmationModal;
